// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const lumberCamp = defineModel({
  id: "lumber-camp",
  batchId: "future",
  name: "Lumber camp",
  tags: ["building","lumber","camp","low-poly","age-of-mcp","future"],
  summary: "A lumber camp — fells trees and feeds logs into the timber chain.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.6,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 0.4, 0.08), color: "#6f4a26", position: [-0.42, 0.34, -0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.4, 0.08), color: "#6f4a26", position: [0.42, 0.34, -0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.4, 0.08), color: "#6f4a26", position: [-0.42, 0.34, 0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.4, 0.08), color: "#6f4a26", position: [0.42, 0.34, 0.42] },
      { geometry: new THREE.BoxGeometry(0.92, 0.32, 0.08), color: "#8a5a30", position: [0, 0.3, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.45, 0.35, -0.45] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.45, 0.35, -0.45] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [-0.45, 0.35, 0.45] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.7, 4), color: "#6b4a26", position: [0.45, 0.35, 0.45] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 0.7, 0.08), color: "#6f4a26", position: [-0.42, 0.49, -0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.7, 0.08), color: "#6f4a26", position: [0.42, 0.49, -0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.7, 0.08), color: "#6f4a26", position: [-0.42, 0.49, 0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.7, 0.08), color: "#6f4a26", position: [0.42, 0.49, 0.42] },
      { geometry: new THREE.BoxGeometry(0.92, 0.56, 0.08), color: "#8a5a30", position: [0, 0.42, -0.42] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.45, 0.5, -0.45] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.45, 0.5, -0.45] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [-0.45, 0.5, 0.45] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1, 4), color: "#6b4a26", position: [0.45, 0.5, 0.45] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.14, 1), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 0.7, 0.08), color: "#6f4a26", position: [-0.42, 0.49, -0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.7, 0.08), color: "#6f4a26", position: [0.42, 0.49, -0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.7, 0.08), color: "#6f4a26", position: [-0.42, 0.49, 0.42] },
      { geometry: new THREE.BoxGeometry(0.08, 0.7, 0.08), color: "#6f4a26", position: [0.42, 0.49, 0.42] },
      { geometry: new THREE.BoxGeometry(0.92, 0.56, 0.08), color: "#8a5a30", position: [0, 0.42, -0.42] },
      { geometry: new THREE.BoxGeometry(1, 0.06, 0.583095), color: "#5a4634", position: [0, 0.99, 0.25], rotation: [0.54042, 0, 0] },
      { geometry: new THREE.BoxGeometry(1, 0.06, 0.583095), color: "#5a4634", position: [0, 0.99, -0.25], rotation: [-0.54042, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.04, 0.06, 0.06), color: "#463524", position: [0, 1.14, 0] },
      { geometry: new THREE.CylinderGeometry(0.12, 0.13, 0.18, 9), color: "#7a522e", position: [0.18, 0.23, 0.52] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.22, 5), color: "#7a522e", position: [0.18, 0.42, 0.52], rotation: [0.3, 0, 0.2] },
      { geometry: new THREE.BoxGeometry(0.11, 0.04, 0.02), color: "#9aa0a6", position: [0.22, 0.52, 0.56], rotation: [0.3, 0, 0.2] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.5, 8), color: "#9a6a3c", position: [-0.3, 0.21, 0.5], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.5, 8), color: "#9a6a3c", position: [-0.16, 0.21, 0.5], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.5, 8), color: "#9a6a3c", position: [-0.23, 0.34, 0.5], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CircleGeometry(0.07, 8), color: "#c2a070", position: [-0.3, 0.21, 0.75] },
      { geometry: new THREE.CircleGeometry(0.07, 8), color: "#c2a070", position: [-0.16, 0.21, 0.75] },
    ] },
  ],
  animations: [],
});
